<div class="row" *ngIf='_currentUser != null'>
  <div class="col-md-12 col-12 main-content" >
    <router-outlet></router-outlet>
  </div>
</div>
